import styled from '@emotion/styled';
import { Box } from '@mui/material';

export const InfoRoundSelectedBox = styled(Box)`
  height: 80px;
  width: 100%;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 10px;
  display: flex;
  flex-direction: row;

  @media only screen and (max-width: 767px) {
    height: 137px;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .select-round-date-box {
    width: 560px;
    height: 80px;
    align-items: center;
    align-content: center;
    gap: 16px;
    display: flex;
    flex-direction: row;

    @media only screen and (max-width: 767px) {
      width: 90%;
      gap: 5px;
      align-self: center;
      display: flex;
      flex-direction: column;
    }
  }

  .round-date-box {
    width: 180px;
    height: 48px;

    @media only screen and (max-width: 767px) {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: row;
    }
  }

  .divider-vertical {
    height: 48px;

    @media only screen and (max-width: 767px) {
      display: none;
    }
  }

  .round-date-text {
    font-size: 18px;
    line-height: 22px;
    white-space: pre-wrap;
  }

  .cancel-selected-round-button {
    width: 144px;
    height: 40px;
    align-self: center;

    @media only screen and (max-width: 767px) {
      width: 100%;
      margin-top: 12px;
    }
  }
`;
